import React, {useState} from 'react'
import {Button, Modal} from "antd";
import {deleteShippingOrder} from "../../services/serviceShippingOrder";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const ShippingOrderDelete = ({shippingOrder, updater}) => {
    const [deleteModal, setDeleteModal] = useState(false)
    const [loadings, setLoadings] = useState([])

    const handleDeleteClick = (decision) => {
        if (decision){
            enterLoadingState(setLoadings)
            deleteShippingOrder(shippingOrder.id)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setDeleteModal(!deleteModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        }else{
            setDeleteModal(!deleteModal)
        }
    }

    return(
        <React.Fragment>
            <Button type={'link'} danger onClick={()=>setDeleteModal(!deleteModal)}>Sil</Button>

            <Modal
                open={deleteModal}
                onCancel={() => setDeleteModal(!deleteModal)}
                title={'Silmek istediğinizden emin misiniz ?'}
                footer={[
                    <Button type={'primary'} danger key={'submitButton'} loading={loadings[0]} onClick={()=> handleDeleteClick(true)}>Onayla</Button>,
                    <Button key={'cancelButton'} onClick={() => handleDeleteClick(false)}>Vazgeç</Button>
                ]}
            >

            </Modal>

        </React.Fragment>
    )
}
export default ShippingOrderDelete